import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const TableColumn = () => (
  <ComponentDocs
    name="<Table.Column/>"
    entry="TableColumn"
    propsEntry="TableColumnProps"
    namespace="TableColumns"
  >
    <ComponentExample
      name="Field column"
      import={import("examples/Tables/TableColumn/FieldColumnExample")}
      rawImport={import("examples/Tables/TableColumn/FieldColumnExample?raw")}
    />
    <ComponentExample
      name="Render column"
      import={import("examples/Tables/TableColumn/RenderColumnExample")}
      rawImport={import("examples/Tables/TableColumn/RenderColumnExample?raw")}
    />
    <ComponentExample
      name="Component column"
      import={import("examples/Tables/TableColumn/ComponentColumnExample")}
      rawImport={import(
        "examples/Tables/TableColumn/ComponentColumnExample?raw"
      )}
    />
    <ComponentExample
      name="Sortable column header"
      import={import("examples/Tables/TableColumn/SortableColumnHeaderExample")}
      rawImport={import(
        "examples/Tables/TableColumn/SortableColumnHeaderExample?raw"
      )}
    />
  </ComponentDocs>
);

export default TableColumn;
